package com.klantenstop.web.components.dialogs.manageCompanyReview

import com.klantenstop.web.data.models.domain.Review
import com.materialkobweb.utils.ViewModel
import kotlinx.coroutines.flow.MutableSharedFlow
import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.SharedFlow
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.asSharedFlow
import kotlinx.coroutines.flow.asStateFlow
import kotlinx.coroutines.flow.update
import kotlinx.coroutines.launch

class ManageCompanyReviewViewModel(
    currentUserReview: Review? = null
) : ViewModel(), ManageCompanyReviewContract {
    private val _state = MutableStateFlow(
        ManageCompanyReviewContract.State(
            originalReview = currentUserReview,
            rating = currentUserReview?.rating ?: 0,
            reviewText = currentUserReview?.text ?: "",
        )
    )
    override val state: StateFlow<ManageCompanyReviewContract.State> = _state.asStateFlow()

    private val _effect = MutableSharedFlow<ManageCompanyReviewContract.Effect>()
    override val effect: SharedFlow<ManageCompanyReviewContract.Effect> = _effect.asSharedFlow()

    override fun sendIntent(intent: ManageCompanyReviewContract.Intent) = coroutineScope.launch {
        when (intent) {
            is ManageCompanyReviewContract.Intent.UpdateReviewRating -> updateState { it.copy(rating = intent.rating) }
            is ManageCompanyReviewContract.Intent.UpdateReviewText -> updateState { it.copy(reviewText = intent.reviewText) }
            is ManageCompanyReviewContract.Intent.SaveCompanyReview -> {
                updateState { it.copy(hasAttemptedSave = true) }
                val currentState = state.value
                if (!currentState.isFormValid) return@launch
                val effect = ManageCompanyReviewContract.Effect.SaveCompanyReview(
                    rating = currentState.rating,
                    reviewText = currentState.reviewText
                )
                emitEffect(effect)
            }
        }
    }

    override fun emitEffect(effect: ManageCompanyReviewContract.Effect) = coroutineScope.launch {
        _effect.emit(effect)
    }

    override fun updateState(block: (ManageCompanyReviewContract.State) -> ManageCompanyReviewContract.State) {
        _state.update(block)
    }
}
